import { render } from "./ModalSoumettreFichier.vue?vue&type=template&id=3673c090"
import script from "./ModalSoumettreFichier.vue?vue&type=script&lang=js"
export * from "./ModalSoumettreFichier.vue?vue&type=script&lang=js"

import "./ModalSoumettreFichier.vue?vue&type=style&index=0&id=3673c090&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__